import Plus from '../../src/legacy/Plus';
export default Plus;
